import { useState, useEffect, useRef } from "react";
import { CiChat1 } from "react-icons/ci";
import { MdEmail } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
// import "./SupportBubble.scss";

export default function SupportBubble() {
  const [open, setOpen] = useState(false);
  const bubbleRef = useRef(null);

  // close when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (bubbleRef.current && !bubbleRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  

  return (
    <div className="support-bubble-container" ref={bubbleRef}>
      <div className={`support-popup ${open ? "open" : ""}`}>
        <p className="title">Need help?</p>

        <a href="mailto:support@nexusforge.com" className="support-item">
          <MdEmail />
          Email support
        </a>

        <a
          href="https://wa.me/message/UOOGIUDWBG5YL1"
          target="_blank"
          rel="noopener noreferrer"
          className="support-item"
        >
          <FaWhatsapp />
          Talk on WhatsApp
        </a>
      </div>

      <button
        className="support-bubble"
        onClick={() => setOpen(!open)}
      >
        <CiChat1 />
      </button>
    </div>
  );
}
